// @flow

import React from 'react';
import { withTheme } from 'styled-components';
import { FakeButton } from '../button';
import Divider from '../divider';
import type { Theme } from '../../types';
import DeliveryTime from '../deliveryTime';
import {
  PromotionWrapper,
  Container,
  ContentContainer,
  PriceWrapper,
  TitleWrapper,
  DiscountWrapper,
} from './promotionCarBlock.styled';
import {
  Specs,
  Title,
  Price,
  Payment,
  Remarks,
  Image,
  Discount,
  FromPrice,
  PromotionImageContainer as ImageContainer,
  NotAvailableOverlay,
  Capsule,
} from './atoms';
import Ribbon from '../ribbon';
import withDeprecation from '../withDeprecation';

type TextProps = {
  deliveryText?: ?string,
  discountText?: string,
  reservedText?: string,
  paymentText?: string,
  buttonText: string,
  remarkText: string,
  notAvailableText: string,
};

type ComponentProps = {
  className?: ?string,
  price: string,
  make: string,
  model: string,
  engine: string,
  power: string,
  fueltype: string,
  hasDiscount?: ?boolean,
  discountPrice?: number,
  configLink: ?string,
  preSelectedPackage?: ?string, // eslint-disable-line react/no-unused-prop-types
  modelInfoLink: ?string,
  isReserved: ?boolean,
  defaultImage?: ?string,
  theme: any,
  isAvailable: boolean,
  nr?: string,
  title?: string,
  subtitle?: string,
  background?: string,
};

type Props = ComponentProps & TextProps;

const CarBlock = ({
  className,
  price,
  make,
  model,
  engine,
  power,
  fueltype,
  defaultImage,
  paymentText,
  discountText,
  reservedText,
  buttonText,
  remarkText,
  deliveryText,
  notAvailableText,
  hasDiscount,
  discountPrice,
  configLink,
  modelInfoLink,
  isReserved,
  theme,
  isAvailable,
  nr,
  title,
  subtitle,
  background,
}: Props) => {
  const { carblock: { priceJustifyContent, buttonProps } }: Theme = theme;
  return (
    <PromotionWrapper
      className={className}
      href={modelInfoLink || configLink}
    >
      <Container>
        {!isAvailable && (
          <NotAvailableOverlay>
            <Capsule>{notAvailableText}</Capsule>
          </NotAvailableOverlay>
        )}
        {discountText && (
          <Discount>{discountText}</Discount>
        )}
        <Ribbon title="justlease" subTitle={nr} />
        <ImageContainer background={background}>
          {defaultImage && (
            <Image
              url={defaultImage}
              alt={`${make} ${model}`}
              isReserved={isReserved}
              reservedText={reservedText}
            />
          )}
        </ImageContainer>
        <ContentContainer>
          <TitleWrapper>
            {title
              && <Title
                make={title}
              />}
            {!title
              && <Title
                make={make}
                model={model}
              />}
            {!subtitle
              && <Specs
                engine={engine}
                power={power}
                fueltype={fueltype}
              />}
            {subtitle
              && <Specs
                engine={subtitle}
              />}
          </TitleWrapper>
          <Divider
            marginBottom=".6rem"
            width="100%"
          />
          <PriceWrapper priceJustifyContent={priceJustifyContent}>
            {hasDiscount && discountPrice && (
              <DiscountWrapper>
                <FromPrice displayCurrencySymbol amount={Number(price)} />
                <Price amount={Number(discountPrice)} />
              </DiscountWrapper>
            )}
            {!(hasDiscount && discountPrice) && (
              <Price amount={Number(price)} />
            )}
            <Payment>{paymentText}</Payment>
          </PriceWrapper>
          <FakeButton
            colors={buttonProps.colors}
            size={buttonProps.size}
            variant={buttonProps.variant}
            fullWidth
            caret
          >
            {buttonText}
          </FakeButton>
          {remarkText && (
            <Remarks>
              {remarkText}
            </Remarks>
          )}
          {deliveryText && (
            <DeliveryTime>{deliveryText}</DeliveryTime>
          )}
        </ContentContainer>
      </Container>
    </PromotionWrapper>
  );
};

CarBlock.defaultProps = {
  className: null,
  deliveryText: null,
  discountText: '',
  preSelectedPackage: '',
  paymentText: '',
  title: '',
  subtitle: '',
  background: 'http://test.api.justlease.nl/app/uploads/2018/09/BACK_01.png',
  reservedText: '',
  hasDiscount: false,
  discountPrice: 0,
  defaultImage: null,
  nr: '0',
};

export default withTheme(withDeprecation({
  deprecations: [{
    renameProp: 'discount',
    newProp: 'hasDiscount',
    deprecatedInVersion: 2,
    comments: 'please use boolean "hasDiscount" instead of "discount"',
  }, {
    removeProp: 'deprecatedProp',
    deprecatedInVersion: 2,
    comments: 'sorry, we no longer support "deprecatedProp"',
  }],
})(CarBlock));
